export const rules = {
  addressLine1: (v) =>
    !v.trim()
      ? "Address is required"
      : v.trim().length < 10
        ? "Enter complete address"
        : "",
  city: (v) =>
    !v.trim()
      ? "City is required"
      : !/^[a-zA-Z\s]+$/.test(v.trim())
        ? "Letters only"
        : "",
  state: (v) =>
    !v.trim()
      ? "State is required"
      : !/^[a-zA-Z\s]+$/.test(v.trim())
        ? "Letters only"
        : "",
  pincode: (v) =>
    !v.trim()
      ? "PIN code is required"
      : /[^0-9]/.test(v.trim())
        ? "Numbers only"
        : v.trim().length !== 6
          ? "Must be 6 digits"
          : "",
};

export const ADDR_REQUIRED = [
  "name",
  "email",
  "address",
  "city",
  "state",
  "pincode",
];

export const ADDRESS_TYPES = ["Home", "Work", "Other"];

export const validateAddr = (name, value) => {
  switch (name) {
    case "name":
      return !value?.trim()
        ? "Name is required"
        : value.trim().length < 2
          ? "Min 2 characters"
          : "";
    case "email":
      return !value?.trim()
        ? "Email is required"
        : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
          ? "Enter valid email"
          : "";
    case "address":
      return !value?.trim()
        ? "Address is required"
        : value.trim().length < 10
          ? "Enter complete address"
          : "";
    case "city":
      return !value?.trim()
        ? "City is required"
        : !/^[a-zA-Z\s]+$/.test(value.trim())
          ? "Letters only"
          : "";
    case "state":
      return !value?.trim()
        ? "State is required"
        : !/^[a-zA-Z\s]+$/.test(value.trim())
          ? "Letters only"
          : "";
    case "pincode":
      return !value?.trim()
        ? "Pincode is required"
        : /[^0-9]/.test(value.trim())
          ? "Numbers only"
          : value.trim().length !== 6
            ? "Must be 6 digits"
            : "";
    case "latitude":
      return String(value ?? "").trim() && isNaN(parseFloat(value))
          ? "Enter a valid number"
          : "";
    case "longitude":
      return String(value ?? "").trim() && isNaN(parseFloat(value))
          ? "Enter a valid number"
          : "";
    default:
      return "";
  }
};

export const EMPTY_ADDR = {
  name: "",
  email: "",
  address_type: "Home",
  address: "",
  city: "",
  state: "",
  pincode: "",
  latitude: "",
  longitude: "",
  is_default: false,
};
